import styled, { css } from 'styled-components';

export const ScrollableContent = styled.div`
  overflow-y: auto;
  height: 100%;
  position: relative;

  ${({ showShadow, theme }) => css`
    &:after {
      content: " ";
      display: block;
      background: linear-gradient(0deg, ${theme.SCROLL_MORE_FILL} 0%, transparent 100%);
      height: 20px;
      width: 100%;
      position: sticky;
      bottom: 0;
      pointer-events: none;
      opacity: ${showShadow ? '1' : '0'};
    }
  `}

  ${({ customStyles }) => customStyles};
`;
export default {};
